import { baseApi } from './baseApi';

export const quotationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getQuotations: builder.query({
      query: (params) => ({ url: '/quotations', params: params || {} }),
      providesTags: ['Quotation'],
    }),
    getQuotation: builder.query({
      query: (id) => `/quotations/${id}`,
      providesTags: (result, error, id) => [{ type: 'Quotation', id }],
    }),
    createQuotation: builder.mutation({
      query: (data) => ({ url: '/quotations', method: 'POST', body: data }),
      invalidatesTags: ['Quotation'],
    }),
    updateQuotation: builder.mutation({
      query: ({ id, ...data }) => ({ url: `/quotations/${id}`, method: 'PUT', body: data }),
      invalidatesTags: ['Quotation'],
    }),
    convertQuotationToOrder: builder.mutation({
      query: (id) => ({ url: `/quotations/${id}/convert-to-order`, method: 'POST' }),
      invalidatesTags: ['Quotation', 'Sales', 'Inventory'],
    }),
    deleteQuotation: builder.mutation({
      query: (id) => ({ url: `/quotations/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Quotation'],
    }),
  }),
});

export const {
  useGetQuotationsQuery,
  useLazyGetQuotationsQuery,
  useGetQuotationQuery,
  useLazyGetQuotationQuery,
  useCreateQuotationMutation,
  useUpdateQuotationMutation,
  useConvertQuotationToOrderMutation,
  useDeleteQuotationMutation,
} = quotationsApi;
